import React from 'react';
import { Side } from '../nav/Side';
import {socialMedia} from '../../utils/socialmedia';

//import styled
import { StyledLinkWrapper, StyledEmailLink } from './Email_styled';


export const Email = ({ isHome }) => (
  <Side  orientation="right">
    <StyledLinkWrapper>
      <StyledEmailLink href={`mailto:${socialMedia.gmail}`}>mamihenintsoaRakotobe@gmail.com</StyledEmailLink>
    </StyledLinkWrapper>
  </Side>
);


export default Email;
